<!--
  This component is composed without using the v-list-item-* components to gain
  more flexibility.
-->
<template>
  <v-container
    class="h-order-content px-3 py-1 fill-height"
    @click.stop="openContent"
  >
    <h-item-main
      :quantity="content.quantity"
      :name="content.name"
      :price="content.itemPrice"
      :print-status="content.printStatus"
      :disabled="disabled"
      :closed="closed"
      :menu="hasSubContents"
      :paid="paid"
    />
    <h-item-modifiers
      v-if="hasModifiers"
      :quantity="content.quantity"
      :modifiers="content.modifiers"
      :paid="paid"
    />
    <h-item-combination
      v-if="content.orderContentCombination"
      :quantity="content.quantity"
      :combination="content.orderContentCombination"
      :paid="paid"
    />
    <h-item-menu
      v-if="hasSubContents"
      v-for="(subContent, i) in formattedSubContents"
      :key="i"
      :content="subContent"
      :paid="paid"
    />
    <h-item-discount
      v-if="hasDiscount"
      :discount="content.discount"
      :amount="content.discountAmount"
    />
    <h-item-notes
      v-if="hasNotes"
      :notes="content.notes"
    />
  </v-container>
</template>

<script>
  import Configurable from '@/Mixins/Configurable'
  import HItemMain from './ItemMain'
  import HItemModifiers from './ItemModifiers'
  import HItemCombination from './ItemCombination'
  import HItemMenu from './ItemMenu'
  import HItemDiscount from './ItemDiscount'
  import HItemNotes from './ItemNotes'

  export default {
    mixins: [
      Configurable,
    ],

    components: {
      HItemMain,
      HItemModifiers,
      HItemCombination,
      HItemMenu,
      HItemDiscount,
      HItemNotes,
    },

    props: {
      content: {
        required: true,
        type: Object,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
      closed: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      paid () {
        return !! this.content.alreadyPaidQuantity && this.$store.state.orders.showPaid
      },
      hasModifiers () {
        return !! this.content.modifiers?.length
      },
      hasSubContents () {
        return !! this.content.subContents?.length
      },
      formattedSubContents () {
        return this.closed || ! this.config('hideMenuContents')
          ? this.content.getFormattedSubContents()
          : []
      },
      hasDiscount () {
        return this.content.discountAmount > 0
      },
      hasNotes () {
        return !! this.content.notes?.length
      },
    },

    methods: {
      openContent () {
        if (this.disabled) {
          return
        }
        this.$emit('open', this.content)
      }
    }
  }
</script>

<style lang="scss">
  .h-order-content {
    min-height: 48px;
    div {
      width: 100%;
    }
  }
  .h-price-paid {
    text-decoration: line-through;
    opacity: .38;
  }
</style>
